/**
 * The sRGB transfer function both ways, in one place. Godot authors every material colour in sRGB
 * and converts on upload, so albedo and emission share one curve. A colour that goes to linear and
 * back lands on the byte it left only while the two halves stay exact inverses.
 */
/**
 * Godot's `Color::srgb_to_linear` (`core/math/color.h:192-198`) for one channel, unclamped: Godot's
 * HDR picker writes channels above 1, and the extrapolating `pow` keeps an HDR emission colour
 * bright enough to cross the glow bright-pass.
 */
export function sRGBChannelToLinear(c) {
    if (c < 0.04045)
        return c / 12.92;
    return Math.pow((c + 0.055) / 1.055, 2.4);
}
/**
 * Godot's `Color::linear_to_srgb` (`core/math/color.h:199-204`) for one channel, unclamped: the
 * inverse of {@link sRGBChannelToLinear}, so an HDR channel above 1 stays above 1.
 */
export function linearChannelToSRGB(c) {
    if (c < 0.0031308)
        return 12.92 * c;
    return 1.055 * Math.pow(c, 1 / 2.4) - 0.055;
}
/** `sRGBChannelToLinear` over an RGB triple. */
export function sRGBToLinearRGB(r, g, b) {
    return [sRGBChannelToLinear(r), sRGBChannelToLinear(g), sRGBChannelToLinear(b)];
}
/**
 * Godot's `Color::get_r8()` (`core/math/color.h:228`): a 0..1 channel rounded to 8 bit, clamped
 * to 0..255. The product is a float, so 0.9 lands on 229.5 and rounds up, where a double gives
 * 229.49999 and rounds down. It lives here, not per rasteriser, since pixels are compared
 * against the engine's.
 */
export function channelToByte(channel) {
    return Math.min(255, Math.max(0, Math.round(Math.fround(Math.fround(channel) * 255))));
}
//# sourceMappingURL=colorSpace.js.map